(function(){
    angular.module('tmx-app').service('TmxDialogService',['$mdDialog','tmxUtility', //
  
  
  //global variables for this script
  //service definition
        function TmxDialogService($mdDialog,tmxUtility){
            var mdDialog;
            var exists;
            var commonTemplateUrl="common/directives/tmxconfirmdialog/tmxconfirmdialog.html";
            var commonController="TmxConfirmDialogCtrl";
            exists=tmxUtility.exists;
            mdDialog=$mdDialog;
            var service=this;
            service.confirmDialog=confirmDialog;

            service.showConfirmDialog = showSimpleConfirmDialog;
            service.showAlertDialog = showAlertDialog;

            function showSimpleConfirmDialog(title, message, callback, negCallback) {
                var confirm = $mdDialog.confirm()
                    .title(title)
                    .htmlContent(message.replace(/\|/g,'<br>'))
                    .ariaLabel(title)
                    .ok('Yes')
                    .cancel('No');

                $mdDialog.show(confirm).then(function () {
                    callback();
                }, function () {
                    if (exists(negCallback)) {
                        negCallback();
                    }
                });
            }


            function showAlertDialog(title, message, callback, okText = null) {
                var alertConfig = {
                    title: title,
                    htmlContent: message,
                    ok: okText ? okText :'Close'
                };
                var alert = $mdDialog.alert(alertConfig);
                $mdDialog
                    .show(alert)
                    .finally(function () {
                        alert = undefined;
                        if (exists(callback)) callback();
                    });
            }

            function confirmDialog(dataconfig,callback,config){
                var dialog=this;
        
                if(exists(config,"config.templateUrl"))
                    dialog.templateUrl=config.templateUrl;
                else
                    dialog.templateUrl=commonTemplateUrl;
        
                if(exists(config,"config.parent"))
                    dialog.parent=config.parent;
                else
                    dialog.parent=angular.element(document.body);
    
                if(exists(config,"config.clickOutsideToClose"))
                    dialog.clickOutsideToClose=config.clickOutsideToClose;
                else
                    dialog.clickOutsideToClose=true;
    
                if(exists(config,"config.controller"))
                    dialog.controller=config.controller;
                else
                    dialog.controller=commonController;
        
                dialog.locals={_config:dataconfig};
    
                dialog.callback=callback;
    
                dialog.show=function(){
                    mdDialog.show({
                        templateUrl: dialog.templateUrl,
                        parent: dialog.parent,
                        clickOutsideToClose:dialog.clickOutsideToClose,
                        controller:dialog.controller,
                        locals: dialog.locals,
    
                    }).then(dialog.callback);
    
    
                }
          
            }
        }]);

        
})();